module.exports = __webpack_public_path__ + "static/oscar-080a356b4faae669c9efe425ba07c5c1.jpeg";